import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";
import CustomButton from "../../../../../components/CustomButton";
import {Grid} from "@mui/material";
import Popup from "../../../../../components/WMS/Mobile/Popup";
import { ReactComponent as WorkstationIcon } from "assets/img/wms/workstation.svg";

AlreadyAssignedWorkstation.propTypes = {
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    handleValid: PropTypes.func.isRequired
};

function AlreadyAssignedWorkstation({open, handleClose, handleValid}) {
    return (
        <Popup
            open={open}
            onClose={handleClose}
            icon={<WorkstationIcon/>}
            title={<FormattedMessage id={"wms.packing.modal.alreadyScannedWorkstation.title"}/>}
            subtitle={<FormattedMessage id={"wms.packing.modal.alreadyScannedWorkstation.subtitle"}/>}
        >
            <Grid container direction={"column"} gap={"16px"}>
                <CustomButton fullWidth onClick={handleValid}>
                    <FormattedMessage id={"wms.packing.modal.alreadyScannedWorkstation.button"}/>
                </CustomButton>
                <CustomButton fullWidth color={"default"} onClick={handleClose}>
                    <FormattedMessage id={"wms.packing.modal.alreadyScannedWorkstation.button.cancel"}/>
                </CustomButton>
            </Grid>
        </Popup>
    );
}

export default AlreadyAssignedWorkstation;